<template>
  <v-app>
    <AppHeader />
    <v-main class="theme">
      <Snackbar :snackbar="$store.state.snackbar" />
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from "../components/header/AppHeader.vue";
import Snackbar from "../components/snackbar/Snackbar.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    Snackbar
  }
};
</script>

<style>
@import "../style.css";
</style>
